import { Location, matchPath } from "react-router-dom-v5-compat";

import { TUTORING_LEAD_SOURCES } from "@seneca/tutoring-service-consts";

import { MODAL_ROUTES } from "routing/routes";

import { TutoringFormModalStep } from "../consts";

export function getNavigateToOneTutoringFormModalOptions({
  step = TutoringFormModalStep.subjectDetails,
  backgroundLocation,
  childId,
  oneToOneTutoringSource
}: {
  step?: TutoringFormModalStep;
  backgroundLocation?: Partial<Location> & Pick<Location, "pathname">;
  childId?: string;
  oneToOneTutoringSource: TUTORING_LEAD_SOURCES;
}) {
  const urlSearchParams = {
    oneToOneTutoringSource,
    step
  };

  return {
    to: MODAL_ROUTES.TUTORING_FORM_JOURNEY.buildPath({}, urlSearchParams),
    pathname: MODAL_ROUTES.TUTORING_FORM_JOURNEY.buildPath({}),
    search: MODAL_ROUTES.TUTORING_FORM_JOURNEY.buildSearch(urlSearchParams),
    state: MODAL_ROUTES.TUTORING_FORM_JOURNEY.buildState({
      background: backgroundLocation,
      childId
    })
  };
}

export function isInOneToOneTutoringFormModal(pathname: string) {
  return matchPath(
    `${MODAL_ROUTES.TUTORING_FORM_JOURNEY.buildPath({})}/*`,
    pathname
  );
}
